import script from "./TableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableComponent.vue?vue&type=script&setup=true&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=f153db5a&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f153db5a"]])

export default __exports__